import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import Layout from './Layout';
import useApiUrlTranslation from './useApiUrlTranslation';

const MonProfil = () => {
    // On récupère aussi isLoading et token pour conditionner l'appel
    const { authHeader, logout, isLoading, token } = useAuth();
    const [profil, setProfil] = useState(null);
    const [error, setError] = useState(null);

    const { t } = useApiUrlTranslation();


    useEffect(() => {
        // Ne rien faire si l'authentification est en cours de chargement ou s'il n'y a pas de jeton
        if (isLoading || !token) {
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const redirectUrl = urlParams.get('redirectUrl');


        const personalizedUserRedirect = (userProfile) => {


            const url = redirectUrl.replace('{id_contact}', userProfile.id_contact || userProfile.id)
                .replace('%7bid_contact%7d', userProfile.id_contact || userProfile.id)
                .replace('%7Bid_contact%7D', userProfile.id_contact || userProfile.id)
                .replace('{id_contact_encrypted}', userProfile.id_contact_encrypted || userProfile.id);

            window.location.href = url;
        }

        fetch('https://www.mlg-consulting.com/smart_territory/form/api.php?action=getMonProfil', {
            headers: {
                ...authHeader() // Ajoute l'en-tête d'autorisation
            }
        })
            .then(res => {
                // Gérer les erreurs HTTP comme 401 Unauthorized
                if (!res.ok) {
                    throw new Error('Session invalide ou expirée. Veuillez vous reconnecter.');
                }
                return res.json();
            })
            .then(data => {
                if (data.success) {
                    setProfil(data.profil);

                    if (redirectUrl) {
                        personalizedUserRedirect(data.profil);
                    }
                } else {
                    // Gérer les erreurs renvoyées par l'API
                    setError(data.message || 'Une erreur est survenue lors de la récupération du profil.');
                    logout(); // Déconnecter l'utilisateur si le jeton est invalide

                    console.log(data)

                }
            })
            .catch(err => {
                // Gérer les erreurs réseau ou celles levées plus haut
                setError(err.message);
                // logout();

            });
        // L'effet dépend maintenant de l'état de chargement et de la présence du jeton
    }, [isLoading, token, authHeader, logout]);

    // Afficher un message pendant que le contexte vérifie le token dans le localStorage
    if (isLoading) {
        return <div>Vérification de la session...</div>;
    }

    // Si pas de token après le chargement, l'utilisateur n'est pas connecté
    if (!token) {
        return <div>Vous n'êtes pas connecté. <a href="/login-redirect" className="text-blue-500">Se connecter</a></div>;
    }

    if (error) {
        return <div className="text-red-500">Erreur : {error}</div>;
    }

    if (!profil) {
        return <div>Chargement du profil...</div>;
    }

    return (<Layout darkMode={true} className="  dark:bg-slate-900"   >
        <div className="min-h-screen  dark:bg-slate-900 flex flex-col justify-center items-center p-4 transition-colors duration-300">
            {/* Card Component */}
            <div className="w-full max-w-sm   dark:bg-neutral-800 border-x border-y border-neutral-200 dark:border-neutral-800 rounded-xl shadow-sm">
                <div className="flex flex-col items-center p-6 sm:p-8">
                    {/* Avatar */}
                    <div className="relative flex h-24 w-24 shrink-0 overflow-hidden rounded-full mb-4">
                        <img
                            src={profil.visuel || `https://ui-avatars.com/api/?name=${profil.prenom}+${profil.nom}&background=0D8ABC&color=fff&size=96`}
                            alt={t('profile.avatar_alt')}
                            className="aspect-square h-full w-full object-cover"
                        />
                    </div>

                    {/* Card Header */}
                    <div className="text-center mb-6">
                        <h3 className="text-2xl font-semibold leading-none tracking-tight text-gray-900 dark:text-gray-100">
                            {t('profile.hello', 'welcome')}, {profil.prenom}!
                        </h3>
                        <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">{profil.mail}</p>
                    </div>

                    {/* Card Footer with Logout Button */}
                    <button
                        onClick={logout}
                        className="dark:text-white w-full inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-white dark:ring-offset-neutral-800 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 dark:focus-visible:ring-slate-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-red-600 text-slate-50 hover:bg-red-700/90 h-10 px-4 py-2"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clipRule="evenodd" />
                        </svg>
                        {t('profile.logout', 'logout')}
                    </button>
                </div>
            </div>
        </div>
    </Layout>
    );
}

export default MonProfil;